require('./manageEmailNotificationHeader.i18n.json');
require('./manageEmailNotificationHeader.tpl.html');
require('./manageEmailNotificationHeaderController.js');

const ManageEmailNotificationHeaderComponent = {
    templateUrl: '/configuration/emailNotification/manageEmailNotification/header/manageEmailNotificationHeader.tpl.html',
    controller: 'manageEmailNotificationHeaderController',
    bindings: {
        templateId: '<'
    }
};

angular.module('ums.configuration')
    .component('uiManageEmailNotificationHeader', ManageEmailNotificationHeaderComponent);
